export default __webpack_public_path__ + "static/media/security03.edca5ce6.png";